// mockTestimonials a été retiré le 8 septembre 2026 : trois témoignages
// inventés — noms, âges, villes, montants — étaient publiés comme de vrais
// avis clients sur l'accueil, la page témoignages et les six pages
// départementales. C'est une pratique commerciale trompeuse au sens des
// articles L.121-2 et L.121-4 11° du code de la consommation.
//
// Ne pas les réintroduire. Les vrais témoignages, recueillis par écrit et avec
// l'accord des personnes, iront dans un fichier de données distinct.

export const mockProjects = [
  {
    id: "salle-de-bain",
    title: "Adapter ma salle de bain",
    shortDescription: "Douche sécurisée, barres d'appui, sol antidérapant",
    fullDescription: "Transformez votre salle de bain en un espace sécurisé et accessible. Nous remplaçons votre baignoire par une douche à l'italienne, installons des équipements de sécurité et améliorons l'accessibilité pour votre confort quotidien.",
    estimatedCost: 18500,
    additionalAids: 1500,
    remainingCost: 1600,
    priceRange: "12 000 - 22 000€",
    duration: "3-5 jours",
    includes: [
      "Remplacement baignoire par douche",
      "Receveur de douche antidérapant", 
      "Barres d'appui et siège de douche",
      "Robinetterie adaptée",
      "Éclairage renforcé",
      "Revêtement mural étanche"
    ]
  },
  {
    id: "accessibilite",
    title: "Solutions d'accessibilité",
    shortDescription: "Monte-escalier, rampes, élargissement des passages",
    fullDescription: "Améliorez la circulation dans votre logement avec nos solutions d'accessibilité sur-mesure. Monte-escaliers, rampes d'accès, élargissement des portes, nous adaptons votre domicile à vos besoins de mobilité.",
    estimatedCost: 25000,
    additionalAids: 3500,
    remainingCost: 6100,
    priceRange: "15 000 - 30 000€",
    duration: "5-10 jours",
    includes: [
      "Monte-escalier ou plateforme élévatrice",
      "Rampes d'accès intérieures/extérieures",
      "Élargissement des ouvertures",
      "Main courantes et barres d'appui",
      "Automatisation des portes",
      "Éclairage adapté des circulations"
    ]
  },
  {
    id: "exterieur",
    title: "Adapter mon extérieur", 
    shortDescription: "Rampes d'accès, éclairage, cheminements sécurisés",
    fullDescription: "Nous vous accompagnons pour monter votre dossier MaPrimeAdapt' pour vos aménagements extérieurs. Nos artisans partenaires réalisent rampes d'accès, éclairage automatique, revêtements antidérapants.",
    estimatedCost: 16000,
    additionalAids: 4200,
    remainingCost: 0,
    priceRange: "10 000 - 20 000€", 
    duration: "3-7 jours",
    includes: [
      "Rampe d'accès extérieure",
      "Éclairage automatique à détection",
      "Revêtement antidérapant",
      "Main courantes extérieures",
      "Seuils de portes adaptés",
      "Signalisation tactile et visuelle"
    ]
  },
  {
    id: "cuisine",
    title: "Adapter ma cuisine",
    shortDescription: "Plans de travail ajustables, rangements accessibles",
    fullDescription: "Réaménagez votre cuisine pour la rendre plus accessible et fonctionnelle. Plans de travail à hauteur variable, rangements accessibles, robinetterie adaptée pour cuisiner en toute autonomie.",
    estimatedCost: 7500,
    additionalAids: 1000,
    remainingCost: 1250,
    priceRange: "5 000 - 12 000€",
    duration: "4-6 jours", 
    includes: [
      "Plans de travail ajustables en hauteur",
      "Rangements tiroirs accessibles",
      "Robinetterie à commande facilitée",
      "Évier adapté PMR",
      "Éclairage sous-meuble LED",
      "Revêtement sol antidérapant"
    ]
  },
  {
    id: "chambre",
    title: "Adapter chambre et salon",
    shortDescription: "Circulation facilitée, éclairage, prises accessibles",
    fullDescription: "Optimisez l'aménagement de vos espaces de vie pour plus de confort et de sécurité. Amélioration des circulations, éclairage adapté, installation de prises et interrupteurs à hauteur accessible.",
    estimatedCost: 4500,
    additionalAids: 600,
    remainingCost: 750,
    priceRange: "3 000 - 7 000€",
    duration: "2-4 jours",
    includes: [
      "Réorganisation des espaces",
      "Éclairage progressif et automatique", 
      "Prises et interrupteurs adaptés",
      "Volets roulants électriques",
      "Revêtements de sol adaptés",
      "Barres d'appui murales"
    ]
  },
  {
    id: "volets-roulants",
    title: "Volets roulants motorisés",
    shortDescription: "Automatisation, sécurité, confort au quotidien",
    fullDescription: "Nous montons votre dossier MaPrimeAdapt' pour l'installation de volets roulants motorisés. Travail souvent demandé et coûteux, nos artisans partenaires assurent une installation de qualité pour votre confort et sécurité.",
    estimatedCost: 7008, // 4 x 1752€
    additionalAids: 500, // aide région
    remainingCost: 1598, // 1598€ de reste à charge
    priceRange: "5 000 - 10 000€",
    duration: "1-2 jours",
    includes: [
      "4 volets roulants motorisés",
      "Télécommandes individuelles", 
      "Programmation horaire possible",
      "Sécurité anti-intrusion renforcée",
      "Isolation thermique améliorée",
      "Installation par artisans labellisés"
    ]
  }
];

export const mockServices = [
  {
    id: 1,
    title: "Accompagnement MaPrimeAdapt'",
    description: "En tant qu'AMO agréé ANAH, nous vous accompagnons de A à Z dans votre projet d'adaptation de logement.",
    features: [
      "Constitution du dossier MaPrimeAdapt'",
      "Diagnostic autonomie liberté à domicile", 
      "Recherche et validation des artisans",
      "Suivi des travaux jusqu'au paiement des aides"
    ],
    price: "Pris en charge intégralement par l'ANAH",
    lien: "/maprimeadapt",
    ancre: "Notre accompagnement MaPrimeAdapt'"
  },
  {
    id: 2,
    title: "Adaptation salle de bain",
    description: "Transformez votre salle de bain en espace sécurisé et accessible avec nos solutions sur-mesure.",
    features: [
      "Douche à l'italienne sécurisée",
      "Barres d'appui et sièges de douche",
      "Sol antidérapant",
      "Éclairage renforcé"
    ],
    price: "À partir de 1 500€ après aides",
    lien: "/salle-de-bain",
    ancre: "Adapter une douche ou une salle de bain"
  },
  {
    id: 3,
    title: "Solutions d'accessibilité",
    description: "Améliorez la circulation dans votre logement avec nos équipements d'accessibilité.",
    features: [
      "Monte-escaliers et ascenseurs",
      "Rampes d'accès",
      "Élargissement des passages",
      "Automatisation des ouvertures"
    ],
    price: "À partir de 2 000€ après aides",
    lien: "/accessibilite",
    ancre: "Solutions d'accessibilité du logement"
  }
];

// La FAQ vit désormais dans utils/faqMaPrimeAdapt.js : une seule source
// pour l'affichage et pour le balisage FAQPage.

export const mockEligibilityCheck = (formData) => {
  const { age, situation, revenus, logementType, departement } = formData;
  
  // Vérification éligibilité
  let eligible = false;
  let message = "";
  let tauxPriseEnCharge = 0;
  let montantMaximum = 0;

  // Vérification âge et situation - STRICTE
  if (age === "70-plus") {
    // 70 ans et plus = éligible automatiquement
    eligible = true;
  } else if (age === "60-69" && situation === "perte-autonomie") {
    // 60-69 ans SEULEMENT avec perte d'autonomie
    eligible = true;
  } else if (situation === "handicap") {
    // Situation de handicap = éligible quel que soit l'âge
    eligible = true;
  }
  // SINON = NON ÉLIGIBLE (notamment moins de 70 ans ET autonome)

  // Vérification revenus
  if (eligible && !["tres-modestes", "modestes"].includes(revenus)) {
    eligible = false;
    message = "Vos revenus dépassent les plafonds MaPrimeAdapt'. Contactez-nous pour étudier d'autres solutions de financement.";
  }

  // Vérification logement - pas de blocage pour le social
  // Note: Les locataires du parc social sont éligibles mais avec démarches spécifiques

  // Vérification département disponible (mise à jour 2025)
  if (eligible && !["75", "77", "91", "92", "93", "95"].includes(departement)) {
    if (["78", "94"].includes(departement)) {
      eligible = false;
      message = "Nous n'intervenons pas encore dans ce département. Habilitation en cours. Vous pouvez nous laisser vos coordonnées pour être recontacté dès l'ouverture.";
    } else {
      eligible = false;
      message = "Nous intervenons uniquement en Île-de-France dans les départements où nous sommes habilités par l'ANAH.";
    }
  }

  // Calcul du taux et montant si éligible
  if (eligible) {
    if (revenus === "tres-modestes") {
      tauxPriseEnCharge = 70;
      montantMaximum = 15400; // 70% de 22000€
    } else if (revenus === "modestes") {
      tauxPriseEnCharge = 50;
      montantMaximum = 11000; // 50% de 22000€
    }
    
    // Message adapté selon le type de logement
    if (logementType === "locataire-social") {
      message = "Vous êtes éligible à MaPrimeAdapt' ! En tant que locataire du parc social, des démarches spécifiques s'appliquent (accord du bailleur social requis). Nous vous accompagnons dans ces démarches.";
    } else {
      message = "Vous êtes éligible à MaPrimeAdapt' ! Un accompagnement AMO gratuit est inclus.";
    }
  }

  // Messages d'inéligibilité spécifiques et stricts
  if (!eligible && !message) {
    if (age === "moins-60" && situation === "autonome") {
      message = "MaPrimeAdapt' est réservé aux personnes de 70 ans et plus, ou en situation de handicap, ou de 60-69 ans avec perte d'autonomie (GIR 1-6).";
    } else if (age === "60-69" && situation === "autonome") {
      message = "Vous devez justifier d'une perte d'autonomie évaluée (GIR 1 à 6) pour être éligible à MaPrimeAdapt' entre 60 et 69 ans.";
    } else if ((age === "moins-60" || age === "60-69") && situation === "autonome") {
      message = "MaPrimeAdapt' n'est pas accessible aux personnes autonomes de moins de 70 ans.";
    } else {
      message = "Vous ne remplissez pas les critères d'éligibilité MaPrimeAdapt'.";
    }
  }

  return {
    eligible,
    message,
    tauxPriseEnCharge: eligible ? tauxPriseEnCharge : 0,
    montantMaximum: eligible ? montantMaximum : 0
  };
};